import {
  PostHomebannerInterface,
  DeleteHomebannerInterface,
  UpdateHomebannerInterface,
} from '@/data/payload/contracts/HomebannerRequest'

export class UpdateHomebannerRequest implements UpdateHomebannerInterface {
  private name: string
  private imageId: number

  constructor(name: string, imageId: number) {
    this.name = name
    this.imageId = imageId
  }
  public toJSON() {
    const data = {
      name: this.name,
      image_id: this.imageId,
    }
    return JSON.stringify({
      data,
    })
  }
}
export class DeleteHomebannerRequest implements DeleteHomebannerInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class HomebannerApiRequest implements PostHomebannerInterface {
  private name: string
  private imageId: number

  constructor(name: string, imageId: number) {
    this.name = name
    this.imageId = imageId
  }

  public toJSON() {
    const data = {
      name: this.name,
      image_id: this.imageId,
    }

    return JSON.stringify({
      data,
    })
  }
}
